import { Box, useBreakpointValue } from '@chakra-ui/react'
import _ from 'lodash'
import { ItList } from 'types/graphql'

import { BrandColor } from 'src/types'

import { BuyOptions } from '../..'
import FooterOverlay from '../../FooterOverlay/FooterOverlay'

import Body from './Body/Body'

const UnlockAction: React.FC<{
  withEmailPaywall: boolean
  emailElRef: React.MutableRefObject<HTMLInputElement>
  itList: ItList
  buy(options?: BuyOptions): unknown
  buyIsLoading: boolean
  isPreview: boolean
  brandColor: BrandColor
  locked: boolean
}> = ({
  withEmailPaywall,
  emailElRef,
  itList,
  buy,
  buyIsLoading,
  brandColor,
  isPreview,
  locked,
}) => {
  const isSmMd = useBreakpointValue({ sm: true, lg: false })
  if (!locked || isSmMd === undefined || isPreview) return null
  const Content = (
    <Body
      withEmailPaywall={withEmailPaywall}
      emailElRef={emailElRef}
      itList={itList}
      buy={buy}
      buyIsLoading={buyIsLoading}
      brandColor={brandColor}
    />
  )

  return isSmMd ? (
    <FooterOverlay darkBackgroundOnFocus={withEmailPaywall}>
      {Content}
    </FooterOverlay>
  ) : (
    <Box px={{ base: 4, lg: isPreview ? 4 : 24 }} mb={6}>
      {Content}
    </Box>
  )
}

export default UnlockAction
